import { CaseStudy } from 'features/CaseStudy';
import { CASE_STUDIES, CaseStudyName } from 'features/Home/CaseStudies/constants';
import { useParams } from 'react-router';
import { isDefined } from 'utils/isDefined';

const CASE_STUDY_PATH_TO_CASE_STUDY_NAME: Record<string, { caseStudy: CaseStudyName; pageTitle: string }> = {
  'industrial-iot-asset-monitoring-platform-fortify': {
    caseStudy: CASE_STUDIES.FORTIFY,
    pageTitle: 'Fortify IoT Case Study | Custom Industrial IoT Platform by C4Workx',
  },
} as const;

export const CaseStudyPage = () => {
  const { caseStudy } = useParams();

  if (!isDefined(caseStudy)) {
    return null;
  }

  const caseStudyName = CASE_STUDY_PATH_TO_CASE_STUDY_NAME[caseStudy];

  if (!isDefined(caseStudyName)) {
    return null;
  }

  return (
    <>
      <title>{caseStudyName.pageTitle}</title>
      <CaseStudy companyName={caseStudyName.caseStudy} />
    </>
  );
};
